import {ThemeType} from '../enum/ThemeType'

export function resolveThemeType(value: unknown): ThemeType {
  if(typeof value === 'string' && Object.values(ThemeType).includes(value as ThemeType)) {
    return value as ThemeType
  }
  return ThemeType.FiordNight
}
